module.exports = __webpack_public_path__ + "img/no_picture_restaurant.dac77096.jpg";